<mat-toolbar>
  <div class="cds-navbar">
    <div class="left-menu">
      <mat-icon *ngIf="showRouterLink" (click)="navigateBack()">arrow_back</mat-icon>
      <h2 class="headerTitle">{{headerTitle}}</h2>
      <mat-icon *ngIf="showRouterLink && isDeviceDisabled"
        class="mat-icon notranslate secondary-text s-20 material-icons mat-icon-no-color" role="img">
        phonelink_lock
      </mat-icon>
    </div>

    <div class="right-menu">
      <span class="profileName">
        <span class="ml05">{{userName}}</span>
        <span class="circle">
          <mat-icon class="profileIcon">account_circle</mat-icon>
        </span>
        <img [matMenuTriggerFor]="menu" class="arrow" src="../assets/menu-icons/arrow-user-profile.svg"
          alt="menuHamburger">
      </span>

      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="logout()">
          <mat-icon>power_settings_new</mat-icon>
          <span>Log Out</span>
        </button>
      </mat-menu>
    </div>
  </div>
</mat-toolbar>